export default __webpack_public_path__ + "static/annaz-469b8d4233e723d15222960f28d803d9.jpg";